import { Component, OnInit } from '@angular/core';
import { TravelService } from 'src/app/services/travel.service';
import { ActivatedRoute } from '@angular/router';
import { Travel } from 'src/app/models/travel';

@Component({
  selector: 'app-gas-ticket-re',
  templateUrl: './gas-ticket-re.component.html',
  styleUrls: ['./gas-ticket-re.component.css']
})
export class GasTicketReComponent implements OnInit {

  loading:boolean = false;
  travel:Travel;
  lts:number = 0;

  constructor(private travelServ:TravelService, actRoute:ActivatedRoute) {
    this.loading = true;

    actRoute.params.subscribe(params => {
      this.travelServ.getTravel(params.id)
        .then(tr => {
          this.travel = tr;

          this.lts = this.travel.expenses
            .filter(exp => exp.expense_name == 'SUPER DIESEL EXTRA')
            .map(exp => exp.quantity)
            .reduce((ant, act) => {
              return Number(ant) + Number(act);
            }, 0);

          this.loading = false;
        });
    });
  }

  ngOnInit() {
  }

}
